<template>
  <div class="caculate-error">
    <div class="message">
      <p class="title">{{ title }}</p>
      <div class="desc"><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoveCaculateError',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/fonts/font.less';
@import '../../../assets/css/main.less';
.caculate-error {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 24px;
  .message {
    text-align: center;
    display: flex;
    width: 100%;
    flex-direction: column;
    .title {
      .font-regular;
      font-weight: 400;
      color: @app-black-color;
    }
    .desc {
      .font-light;
      word-break: break-all;
      font-size: 12px;
      font-weight: 300;
      color: @app-body-color;
      padding-top: 16px;
    }
  }
}
</style>
